import { iNoteConfig } from '@/interface/note-system';
import request from '@/utils/request';
/* 保存短信风控配置 */
export const postNoteConfig = (data: iNoteConfig): Promise<any> =>
  request({
    url: '/api/v1/omc/sms/risk/config',
    method: 'post',
    data,
  });

/* 获取短信风控配置 */
export const getNoteConfig = (): Promise<any> =>
  request({
    url: '/api/v1/omc/sms/risk/config',
    method: 'get',
  });
/* 保存短信风控规则黑名单 */
export const postNoteRulers = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/sms/risk/rbl/rulers',
    method: 'post',
    data,
  });
/* 获取短信风控规则黑名单 */
export const getNoteRulers = (kind: string): Promise<any> =>
  request({
    url: '/api/v1/omc/sms/risk/rbl/rulers?kind=' + kind,
    method: 'get',
  });
